<template>
  <div class="sidebar d-flex flex-column justify-content-between">
    <div>
      <div
        v-for="item in menu.top"
        :key="item.title"
        class="sidebar-item-group"
      >
        <!-- Si item tiene path o name, se vuelve clickeable -->
        <div
          class="sidebar-item"
          :title="item.title"
          @click="() => handleClick(item)"
        >
          <span class="label">{{ item.title }}</span>
          <img :src="item.image" class="icon" />
        </div>

        <!-- Submenu -->
        <div v-if="item.children" class="submenu">
          <div
            v-for="child in item.children"
            :key="child.title"
            class="submenu-item"
            @click="() => handleClick(child)"
          >
            <span class="label">{{ child.title }}</span>
            <img :src="child.image" class="icon" />
          </div>
        </div>
      </div>
    </div>

    <div>
      <div
        v-for="item in menu.above"
        :key="item.title"
        class="sidebar-item"
        :title="item.title"
        @click="() => handleClick(item)"
      >
        <span class="label">{{ item.title }}</span>
        <img :src="item.image" class="icon" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

type MenuItem = {
  title: string;
  image: string;
  visible: boolean;
  path?: string;
  children?: MenuItem[];
};

type Menu = {
  top: MenuItem[];
  above: MenuItem[];
};

const props = defineProps<{
  menu: Menu;
}>();

const emit = defineEmits<{
  (e: 'navigate', data: any): void;
}>();

const handleClick = (item: any) => {
  emit('navigate', item);
};
</script>

<style scoped>
.sidebar {
  background-color: #505050;
  width: 70px;
  transition: width 0.2s;
  margin: 5px 0;
  border-radius: 0 20px 20px 0px;
  padding: 10px 0;
  z-index: 1000;
}

.sidebar:hover {
  width: 160px;
}

.sidebar:hover .label {
  display: block;
}

.sidebar:hover .sidebar-item {
  justify-content: space-between;
}

/* Cada grupo (ítem + submenú) */
.sidebar-item-group {
  position: relative;
}

/* Ítem principal */
.sidebar-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  color: white;
  cursor: pointer;
  margin: 0.5rem;
  border-radius: 10px;
  /* white-space: nowrap; */
}
.sidebar-item:hover {
  background-color: #363535;
}

/* Icono y etiqueta */
.icon {
  width: 20px;
  height: 20px;
}
.label {
  /* margin-left: 15px; */
  transition: opacity 0.2s ease-in-out;
  opacity: 0;
  pointer-events: none;
  font-size: 10.5px;
  display: none;
}
.sidebar:hover .label {
  opacity: 1;
  pointer-events: auto;
}

/* Submenú oculto por defecto, con transición de altura y opacidad */
.submenu {
  background-color: #424040;
  flex-direction: column;
  margin: 0px 10px;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transition:
    max-height 0.3s ease,
    opacity 0.3s ease;
}

/* Al hacer hover sobre el grupo, desliza el submenú hacia abajo */
.sidebar-item-group:hover .submenu {
  display: flex;
  max-height: 200px; /* Ajusta según la cantidad de ítems */
  opacity: 1;
}

/* Ítems del submenú */
.submenu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  color: white;
  cursor: pointer;
  /* white-space: nowrap; */
}
.submenu-item:hover {
  background-color: #363535;
}
.submenu-item .icon {
  width: 18px;
  height: 18px;
}
.submenu-item .label {
  margin-left: 10px;
  opacity: 1;
  pointer-events: auto;
}
</style>
